'use strict';

var EditVpn = require('actionGroups/vpn/Vpn');

module.exports = {
  Model: EditVpn,
};
